angular.module('cimerFrontEndApp').controller('CoreQuestionsExclusionModalCtrl', ['$scope', '$uibModalInstance', 'survey', function ($scope, $uibModalInstance, survey) {
    "use strict";

    $scope.survey = survey;

    $scope.persistQuestionsExcluded = function() {

        var result = {};
        result.ExcludedBaseSurveyQuestionIDs = [];

        // Populate result.ExcludedBaseSurveyQuestionIDs from $scope.survey
        for (var i = 0; i < $scope.survey.Sections.length; i++) {
            for (var j = 0; j < $scope.survey.Sections[i].QuestionPrompts.length; j++) {

                // Radio and Text questions will have ExcludeFromReports exposed at this level
                if ($scope.survey.Sections[i].QuestionPrompts[j].hasOwnProperty('ExcludeFromReports') &&
                    $scope.survey.Sections[i].QuestionPrompts[j].ExcludeFromReports) {
                    result.ExcludedBaseSurveyQuestionIDs.push($scope.survey.Sections[i].QuestionPrompts[j].QuestionID);
                }

                // Matrix questions will have ExcludeFromReports exposed within a child Questions property
                if ($scope.survey.Sections[i].QuestionPrompts[j].hasOwnProperty('Questions') &&
                    $scope.survey.Sections[i].QuestionPrompts[j].Questions[0].ExcludeFromReports) {

                    for (var k = 0; k < $scope.survey.Sections[i].QuestionPrompts[j].Questions.length; k++) {
                        result.ExcludedBaseSurveyQuestionIDs.push($scope.survey.Sections[i].QuestionPrompts[j].Questions[k].QuestionID);
                    }
                }
            }
        }

        $uibModalInstance.close(result);
    };

    $scope.cancel = function () {
        $uibModalInstance.dismiss('cancel');
    };

}]);